import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { container as containerStyle, sliceColourTheme } from '../styles/theme';
import FullViewportContainer from './FullViewportContainer';
import { colourThemeType } from '../propTypes';

const TrayContainer = ({ children, classes, className }) => (
  <FullViewportContainer>
    <div className={cn(classes.background, className)}>
      <div className={classes.container}>
        {children}
      </div>
    </div>
  </FullViewportContainer>
);

TrayContainer.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  colourTheme: colourThemeType, // used in styles
};

TrayContainer.defaultProps = {
  children: undefined,
  className: undefined,
  colourTheme: sliceColourTheme.white,
};

export default injectSheet({
  background: {
    backgroundColor: ({ colourTheme: { backgroundColour } }) => backgroundColour,
  },
  container: {
    ...containerStyle,
    paddingTop: theme.spacing.vertical.sm,
    paddingBottom: theme.spacing.vertical.sm,
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing.vertical.md,
      paddingBottom: theme.spacing.vertical.md,
    },
  },
})(TrayContainer);
